// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3DgKB","selects":"Documents_selects__2lSnt"};